import {StyleSheet} from 'react-native';

const styles = {
  calendar: StyleSheet.create({
    modalContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.5)',
    },
    calendarContainer: {
      backgroundColor: '#fff',
      borderRadius: 10,
      padding: 20,
    },
    yearScroll: {maxHeight: 300},
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 20,
    },
    headerText: {
      fontWeight: 'bold',
    },
    selectContainer: {
      paddingHorizontal: 10,
      paddingVertical: 4,
    },
    monthDataOptionsContainer: {
      paddingHorizontal: 10,
      paddingVertical: 6,
      marginTop: 4,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      borderRadius: 10,
    },
    monthDataOptionsText: {textAlign: 'center'},
    yearDataOptionsContainer: {
      paddingHorizontal: 10,
      paddingVertical: 6,
      marginTop: 4,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      borderRadius: 10,
    },
    yearDataOptionsText: {textAlign: 'center'},
    navButton: {
      fontSize: 18,
    },
    weekRow: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      marginBottom: 5,
    },
    weekDay: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    day: {
      fontSize: 16,
      textAlign: 'center',
      width: 30,
      height: 30,
      lineHeight: 30,
    },
    selectedDay: {
      backgroundColor: 'blue',
      color: 'white',
      borderRadius: 15,
    },
    today: {
      borderColor: 'silver',
      borderWidth: 1,
      borderRadius: 15,
    },
    outOfRangeDay: {
      color: 'gray',
    },
    closeButton: {
      marginTop: 20,
      paddingHorizontal: 8,
      paddingVertical: 6,
      backgroundColor: 'silver',
      borderRadius: 40,
      alignItems: 'center',
      position: 'absolute',
      right: -16,
      top: -30,
    },
    closeButtonText: {
      color: 'white',
      fontWeight: 'bold',
    },
  }),
  datePicker: StyleSheet.create({}),
  multiDatePicker: StyleSheet.create({
    container: {
      flex: 1,
    },
    listContainer: {
      width: '100%',
      paddingHorizontal: 24,
      //
      borderWidth: 1,
      borderColor: 'rgba(224, 224, 224, 1)',
      borderRadius: 30,
      color: '#000',
      fontSize: 14,
      flexDirection: 'row',
      marginTop: 10,
      paddingTop: 10,
      paddingLeft: 16,
      marginBottom: 16,
      minHeight: 120,
      flexWrap: 'wrap',
    },
    itemContainer: {
      backgroundColor: 'rgba(29, 92, 66, 1)',
      paddingHorizontal: 10,
      justifyContent: 'center',
      height: 30,
      borderRadius: 30,
      marginRight: 20,
      marginBottom: 20,
    },
    itemCloseButton: {
      position: 'absolute',
      top: -14,
      right: -14,
      backgroundColor: 'silver',
      paddingHorizontal: 8,
      paddingVertical: 4,
      borderRadius: 20,
    },
    itemStyle: {
      color: 'white',
    },
    textError: {
      color: '#f00',
      fontSize: 14,
    },
  }),
};

export default styles;
